'use client';

import { ContextMenuCustom } from '#/components/context-menu/context-menu-custom';

import { useMounted } from '#/hooks/use-mounted';

export const ContextMenuProvider = () => {
  const mounted = useMounted();

  if (!mounted) {
    return null;
  }

  return (
    <>
      <ContextMenuCustom />
    </>
  );
};
